import { render, staticRenderFns } from "./BlockDriverModal.vue?vue&type=template&id=8838c370&scoped=true"
import script from "./BlockDriverModal.vue?vue&type=script&lang=ts"
export * from "./BlockDriverModal.vue?vue&type=script&lang=ts"
import style0 from "./BlockDriverModal.vue?vue&type=style&index=0&id=8838c370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8838c370",
  null
  
)

export default component.exports